export default {
  // Modal styles
  tosModalPaper: {
    borderRadius: '8px',
    boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
    '@media (max-width: 600px)': {
      margin: '20px',
      maxHeight: 'calc(100% - 40px)'
    }
  },
  tosHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '24px 24px 16px 24px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    backgroundColor: '#f7f7f7'
  },
  tosCloseButton: {
    padding: 8,
    color: 'rgba(0, 0, 0, 0.54)',
    marginRight: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)'
    }
  },
  tosDialogActions: {
    padding: '20px 24px',
    justifyContent: 'center',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    backgroundColor: '#f7f7f7'
  },
  tosTitle: {
    fontWeight: 700,
    flex: 1,
    textAlign: 'left',
    paddingLeft: '8px',
    fontSize: '1.25rem',
    letterSpacing: '0.5px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  tosContent: {
    padding: '24px 24px',
    lineHeight: '1.6'
  },
  tosSection: {
    marginBottom: 24
  },
  tosSectionTitle: {
    fontWeight: 600,
    marginBottom: '12px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  tosSectionContent: {
    color: 'rgba(0, 0, 0, 0.7)',
    lineHeight: '1.6'
  },
  tosLastUpdated: {
    display: 'block',
    marginTop: 32,
    fontStyle: 'italic',
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '0.85rem'
  },
  
  // Checkbox styles
  tosCheckboxContainer: {
    marginTop: 16,
    marginBottom: 16,
    display: 'flex',
    flexDirection: 'column'
  },
  tosLink: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: '#1976d2',
    fontWeight: 500,
    '&:hover': {
      textDecoration: 'none'
    }
  },
  tosError: {
    marginLeft: 32,
    marginTop: 4,
    fontSize: '0.75rem'
  },
  tosAcceptButton: {
    minWidth: '200px',
    borderRadius: '4px',
    padding: '10px 24px',
    textTransform: 'none',
    fontWeight: 500
  }
};
